import { appendIf } from '@btime/helpers'
import { useTranslation } from 'react-i18next'

import {
  useNonComplianceCompleteAction,
  useNonComplianceCreateActionPlanAction,
  useNonComplianceReopenAction
} from './actions'

export const useNonComplianceFastActionsList = (item = {}, opts = {}) => {
  const { t } = useTranslation('common')
  const hide = opts.hide || []

  const completeAction = useNonComplianceCompleteAction(item)
  const reopen = useNonComplianceReopenAction(item)
  const createActionPlan = useNonComplianceCreateActionPlanAction(item)

  return [
    ...appendIf(completeAction.hasPermission, {
      value: t('markAsCompleted'),
      icon: 'BsCheckSquare',
      onClick: completeAction.click
    }),

    ...appendIf(createActionPlan.hasPermission, {
      value: t('createActionPlan'),
      icon: 'BsBookmarkPlus',
      onClick: createActionPlan.click
    }),

    ...appendIf(reopen.hasPermission, {
      value: t('reopen'),
      icon: 'BsInboxFill',
      onClick: reopen.click
    })
  ]
}
